
export default {
    data() {
        return {
            show: false,
            uploadingImage: true
        }
    },

    created() {

        if (this.alreadyShow || this.image) {
            this.show = true
            this.uploadingImage = false
        }
    },

    computed: {
        isGif() {
            return this.image.indexOf('.gif') > -1
        },
    },

    watch: {
        image(val) {
            if (val) {
                this.uploadingImage = false
            } else {
                if (!this.alreadyShow) {
                    this.show = false
                }
            }
        }
    },

    methods: {
        openUploadMedia(isEdit) {
            let mediaObject = {
                open: true,
                location: this.location,
                questionIndex: this.questionIndex,
                answerIndex: this.answerIndex
            }

            if (isEdit && !this.isGif) {
                const imageName = this.image.split('?')[0].split('/').pop()
                mediaObject.img_url = this.imageOriginal ? this.imageOriginal : this.image
                mediaObject.image_original = this.imageOriginal ? this.imageOriginal : this.image
                mediaObject.source = this.imageSource
                mediaObject.coordinates = this.imageCoordinates
                mediaObject.image_name = 'image.jpeg'
                mediaObject.isEdit = true

                if (this.image.indexOf('data:image') == -1) {
                    mediaObject.image_name = imageName
                }
            }

            this.$store.commit('toggleOpenUploadMedia', mediaObject)
        },

        setNewSoureURL(source) {
            return new URL('/', source)
        },

        removeImage() {
            this.$emit('remove')
        }
    }
}
